import React,{useEffect, useState} from 'react';
import "./css/Account.css";
import { useStateValue } from './StateProvider';
import { auth } from "../firebase";
import { useHistory } from "react-router-dom";
import AddedProduct from "./AddedProduct";
import { Add, ShoppingBag, ShoppingBagSharp } from '@mui/icons-material';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { firestore } from '../firebase';
import NewProduct from './NewProduct';
import CustomerProduct from './CustomerProduct';
import { Cancel, Check, CreditCard, Layers, LocalShipping, Pending, ShoppingCart, ShoppingCartTwoTone, Today } from '@mui/icons-material';

function Account() {
  const history = useHistory();
  const [{basket, user}, dispatch] = useStateValue();
  const [orderIds, setOrderIds] = useState([]);
  const [theOrders, setTheOrders] = useState([]);
  const [matchedOrders, setMatchedOrders] = useState([]);
  const [activeOrders, setActiveOrders] = useState([]);
  const [deliveredOrders, setDeliveredOrders] = useState([]);
  const [spentAllTime, setSpentAllTime] = useState();
  const [spentThisMonth, setSpentThisMonth] = useState();
  const [userAddress, setUserAddress] = useState('');

  const handleAuth = () => {
    if (user) {
      auth.signOut();
      history.push("/login")
    }
  }

  useEffect(() => {
    const userStoriesRef = firestore.collection('orders');

    const unsubscribe = userStoriesRef.onSnapshot((querySnapshot) => {
      const ids = [];
      const userStoriesData = [];

      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
        const data = doc.data();
        userStoriesData.push(data);
      });

      setOrderIds(ids);
      setTheOrders(userStoriesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    const matchingCustomers = theOrders.filter(
      (order) => order?.name === user?.displayName
    );
    setMatchedOrders(matchingCustomers);
  }, [user?.displayName, theOrders]);

  useEffect(() => {
    const matchingOrders = theOrders.filter(
      (order) => order?.name === user?.displayName && order?.status === "Delivered"
    );
    setDeliveredOrders(matchingOrders);
  }, [user?.displayName, theOrders]);

  useEffect(() => {
    const matchingOrders = theOrders.filter(
      (order) => order?.name === user?.displayName && order?.status !== "Delivered" && order?.status !== "Canceled"
    );
    setActiveOrders(matchingOrders);
  }, [user?.displayName, theOrders]);

  useEffect(() => {
    const currentDate = new Date();
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  
    const matchingOrders = theOrders.filter(
      (order) => order?.name === user?.displayName && order?.status === "Delivered"
    );
  
    const spentThisMonth = matchingOrders.reduce((total, order) => {
      const orderDate = order?.orderDate?.toDate();
      if (orderDate && orderDate >= startOfMonth) {
        return total + (parseFloat(order?.price) || 0);
      }
      return total;
    }, 0);
  
    const spentAllTime = matchingOrders.reduce((total, order) => total + (parseFloat(order?.price) || 0), 0);
  
    setSpentThisMonth(spentThisMonth.toFixed(2));
    setSpentAllTime(spentAllTime.toFixed(2));
  }, [user?.displayName, theOrders]);

  const calculateTotalPrice = () => {
    const totalPrice = theOrders.reduce((total, order) => {
      if (
        order?.name === user?.displayName &&
        (order?.status === 'Pending' || order?.status === '')
      ) {
        return total + (parseFloat(order?.price) || 0);
      }
      return total;
    }, 0);
  
    return totalPrice.toFixed(2);
  };

  const deleteAccount = () => {
      const user = firebase.auth().currentUser;
      alert("You are about to delete your account which is not recoverable");

      if (user) {
        // Check the provider IDs associated with the user
        const providerIds = user.providerData.map(provider => provider.providerId);

        if (providerIds.includes('password')) {
          // Delete the user account if authenticated with email and password
          const emailProvider = new firebase.auth.EmailAuthProvider();
          const credentials = firebase.auth.EmailAuthProvider.credential(user.email, prompt('Please enter your password:'));
  
          // Reauthenticate the user
          user.reauthenticateWithCredential(credentials)
            .then(() => {
              history.push("/")
              // Delete the user account
              deleteUserAccount(user);
            })
            .catch(error => {
              // An error occurred while reauthenticating the user
              alert('Failed to reauthenticate: ' + error.message);
            });
        } else if (providerIds.includes('google.com')) {
          // Delete the user account if authenticated with Google
          history.push("/")
          deleteUserAccount(user);
        } else if (providerIds.includes('facebook.com')) {
          // Delete the user account if authenticated with Facebook
          history.push("/")
          deleteUserAccount(user);
        } else if (providerIds.includes('twitter.com')) {
          // Delete the user account if authenticated with Twitter
          history.push("/")
          deleteUserAccount(user);
        } else {
          alert('This feature is only available for accounts with supported providers.');
        }
      }}
  
    const deleteUserAccount = (user) => {
      // Delete the user account
      user.delete()
        .then(() => {
          // Account deleted successfully
          alert('Your account has been deleted.');
          history.push("/")
        })
        .catch(error => {
          // An error occurred while deleting the account
          alert('Failed to delete the account: ' + error.message);
        });
    };

    const addAddress = (e) => {
      e.preventDefault();
      const address = prompt("Enter Your Address");
    
      if (address !== null && address.trim() !== "") {
        const addressRef = firestore.collection("customers").doc(user?.displayName);
    
        addressRef
          .update({ address: address })
          .then(() => {
            alert("Address Updated");
          })
          .catch((error) => {
            console.error('Error updating address:', error);
          });
      } else {
        alert("Address cannot be null or empty");
      }
    };
    

    useEffect(() => {
        const getAddressData = async () => {
          try {
            const addressDoc = await firestore.collection("customers").doc(user?.displayName).get();
    
            if (addressDoc.exists) {
              const data = addressDoc.data();
              setUserAddress(data?.address || 'No address found');
            } else {
              console.log('Document not found');
            }
          } catch (error) {
            console.error('Error fetching address:', error);
          }
        };
    
        getAddressData();
      }, [user?.displayName]);

  return (
    <div className='account'>
      <h2>My Account</h2>
      <div class="account-name">
      <br />
      <h3>Welcome {user ? user?.displayName : "User"}!</h3>
      <h4>{user ? user?.email: "Email Address"}</h4>
      <h4 style={{marginTop: "-1%"}} onClick={addAddress}>{userAddress || `Add your Delivery`}</h4>
        <div className='first-line'>
        <div className='first'>
          <ShoppingBagSharp sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Active Orders</p>
            <p>{activeOrders?.length}</p>
          </div>
        </div>
        <div className='first'>
          <Check  sx={{color: "green", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Completed Order</p>
            <p>{deliveredOrders?.length}</p>
          </div>
        </div>
        <div className='first'>
          <ShoppingBag sx={{color: "green", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>All Time Orders</p>
            <p>{matchedOrders?.length}</p>
          </div>
        </div>
        <div className='first'>
          <ShoppingCartTwoTone sx={{color: "orange", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Spent Monthly</p>
            <p>${spentThisMonth}</p>
          </div>
        </div>
        <div className='first'>
          <LocalShipping sx={{color: "blue", border: "2px solid", borderRadius: "50%", padding: "5px", fontSize: "35px"}}/>
          <div className='first-p'>
            <p>Spent All Time</p>
            <p>${spentAllTime}</p>
          </div>
        </div>
      </div>
      <br /><br />
      </div>

      <br />

      <div class="order-info">
        <br />
        <h3>Order Information</h3>
        <p>Order-Name: {user ? user?.displayName : "User"}</p>
        <p>Order-Address: {userAddress || "Add Delivery Address"}</p>
        <p>Delivery-Date: 2 Days After The Order</p>
        <p>Total-Price of Active Orders: <b>${calculateTotalPrice()}</b></p>
        <br />
      </div>

      <br />

      <div class="orders">
        <br />
        <h4>Active Order ({activeOrders?.length})</h4>
        <div class="orders-row">
        {activeOrders.map((data, index)=> (
          <CustomerProduct key={index} data={data} />
        ))}
        </div>
      </div>

      <br />

      <div class="orders">
        <br />
        <h4>Delivered Order ({deliveredOrders?.length})</h4>
        <div class="orders-row">
        {deliveredOrders.map((data, index)=> (
          <NewProduct key={index} data={data} />
        ))}
        </div>
      </div>

      <div class="buttons">
      <button onClick={handleAuth}>Sign-Out</button>
      <button onClick={deleteAccount}>Close-Account</button>
      </div>

    </div>
  )
}

export default Account